import styled, { css } from 'styled-components';
import { Colors, DropdownListItem, FInter, FlexBox} from '@brg/ui';
import { LayoutConst } from "core/modules";

export const ProjectSearchBarRoot = styled(FlexBox)`
    ${DropdownListItem} {
        font-size: 15px;
        line-height: 20px;
    }
`

export const HoverItemWithSvg = styled(FInter.SmallTextFlex)`
    align-items: center;
    svg {
        opacity: 0.47;
        transition: opacity 0.2s;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const SearchBarWrapper = styled(FlexBox)`
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        place-items: flex-start;
    }
`;

export const JustTable = styled.table<{ isTeamEdit?: boolean, isLMSEdit?: boolean, disabled?: boolean }>`
    border-collapse: collapse;
    width: 100%;

    .id-input {
        max-width: 90px;
        min-width: 90px;
    }

    .checkbox-with-label {
        div:last-child {
            white-space: nowrap;
            color: rgba(144, 144, 144, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }
    }

    ${({ disabled }) =>
            disabled && css`
            pointer-events: none;
            opacity: 0.9;
    `}

    ${({ isTeamEdit }) => isTeamEdit ? null : css`
        border: 1px solid #f2f2f2 !important;

        @media(max-width: ${LayoutConst.screen.md}px) {
            max-width: 760px;
            margin: 0 auto;
        }
        @media(max-width: 800px) {
            max-width: 720px;
        }
    `};

    th, td {
        text-align: left;
        padding: ${({ isTeamEdit }) => isTeamEdit ? '8px 12px' :  '8px 16px'};
        height: 48px;

        @media(max-width: ${LayoutConst.screen.s}px) {
            padding: ${({ isTeamEdit }) => isTeamEdit ? '8px' :  '8px 16px'};
        }
    }

    th {
        ${({ isTeamEdit }) => isTeamEdit ? css`
            background-color: transparent;
            color: #909090;
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;

            @media(max-width: ${LayoutConst.screen.md}px) {
                font-size: 13px;
                line-height: 16px;
            }
        ` : css`
            background-color: #151414;
            color: #ffffff;
    `};

    }

    td:last-child {
        text-align: right;
    }

    tr:nth-child(even) {
        ${({ isTeamEdit }) => isTeamEdit ? null : css`
            background-color: #f2f2f2;
            color: #000;
        `};
    }

  ${({ isLMSEdit }) => isLMSEdit && css`
    th {
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.3px;
      height: auto;
      color: #909090;
    }

    td {
        height: 36px;
    }
  `};
`;


export const RequiredLabel = styled.th`
  &.required-label {
    position: relative; 
    
    &::after {
      content: '*';
      color: #C64839;
      margin-left: 4px; 
      font-size: inherit;
    }
  }
`;
export const RequiredSpan = styled.span`
  &.required-label {
    position: relative; 
    
    &::after {
      content: '*';
      color: #C64839;
      margin-left: 4px; 
      font-size: inherit;
    }
  }
`;

export const AdminSlideButtonContainer = styled(FlexBox)`
    
    

    @media(max-width: ${LayoutConst.screen.s -1}px){
        .white_theme_project_underline {
            margin-bottom: 0;
            padding-bottom: 0;
        }
    }

`;
import styled, { css } from 'styled-components';
import { Colors, DropdownListItem, FInter, FlexBox} from '@brg/ui';
import { LayoutConst } from "core/modules";

export const ProjectSearchBarRoot = styled(FlexBox)`
    ${DropdownListItem} {
        font-size: 15px;
        line-height: 20px;
    }
`

export const HoverItemWithSvg = styled(FInter.SmallTextFlex)`
    align-items: center;
    svg {
        opacity: 0.47;
        transition: opacity 0.2s;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const SearchBarWrapper = styled(FlexBox)`
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        place-items: flex-start;
    }
`;

export const JustTable = styled.table<{ isTeamEdit?: boolean, isLMSEdit?: boolean, disabled?: boolean }>`
    border-collapse: collapse;
    width: 100%;

    .id-input {
        max-width: 90px;
        min-width: 90px;
    }

    .checkbox-with-label {
        div:last-child {
            white-space: nowrap;
            color: rgba(144, 144, 144, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }
    }

    ${({ disabled }) =>
            disabled && css`
            pointer-events: none;
            opacity: 0.9;
    `}

    ${({ isTeamEdit }) => isTeamEdit ? null : css`
        border: 1px solid #f2f2f2 !important;

        @media(max-width: ${LayoutConst.screen.md}px) {
            max-width: 760px;
            margin: 0 auto;
        }
        @media(max-width: 800px) {
            max-width: 720px;
        }
    `};

    th, td {
        text-align: left;
        padding: ${({ isTeamEdit }) => isTeamEdit ? '8px 12px' :  '8px 16px'};
        height: 48px;

        @media(max-width: ${LayoutConst.screen.s}px) {
            padding: ${({ isTeamEdit }) => isTeamEdit ? '8px' :  '8px 16px'};
        }
    }

    th {
        ${({ isTeamEdit }) => isTeamEdit ? css`
            background-color: transparent;
            color: #909090;
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;

            @media(max-width: ${LayoutConst.screen.md}px) {
                font-size: 13px;
                line-height: 16px;
            }
        ` : css`
            background-color: #151414;
            color: #ffffff;
    `};

    }

    td:last-child {
        text-align: right;
    }

    tr:nth-child(even) {
        ${({ isTeamEdit }) => isTeamEdit ? null : css`
            background-color: #f2f2f2;
            color: #000;
        `};
    }

  ${({ isLMSEdit }) => isLMSEdit && css`
    th {
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.3px;
      height: auto;
      color: #909090;
    }

    td {
        height: 36px;
    }
  `};
`;


export const RequiredLabel = styled.th`
  &.required-label {
    position: relative; 
    
    &::after {
      content: '*';
      color: #C64839;
      margin-left: 4px; 
      font-size: inherit;
    }
  }
`;
export const RequiredSpan = styled.span`
  &.required-label {
    position: relative; 
    
    &::after {
      content: '*';
      color: #C64839;
      margin-left: 4px; 
      font-size: inherit;
    }
  }
`;

export const AdminSlideButtonContainer = styled(FlexBox)`
    
    

    @media(max-width: ${LayoutConst.screen.s -1}px){
        .white_theme_project_underline {
            margin-bottom: 0;
            padding-bottom: 0;
        }
    }

`;
